/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";

import { emptyHistoryStyle } from "./styles";

import type { FC } from "react";

export const EmptyHistory: FC = () => {
  const { t } = useI18n();

  return <p css={emptyHistoryStyle}>{t("settlementHistory.noHistory")}</p>;
};
